import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { huntersvilleConfig } from "./data";

export default function HuntersvillePage() {
  return <CityPageTemplate config={huntersvilleConfig} />;
}